import React, { useContext } from 'react';
import { OptionsObject, useSnackbar } from 'notistack';
import { AuthenticationResult } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { aquireToken } from './AuthContext';
import { _clientSettings } from '../../config/client-settings';

export const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE'
};

const compileRoute = (route, params) => {
    if (params){
        const props = Object.getOwnPropertyNames(params);

        if (props && props.length > 0){
            route = `${route}?`
            props.filter(x => params[x] !== null && params[x] !== undefined).forEach(prop => route = `${route}${prop}=${params[prop]}&`);
            route = route.substr(0, route.length - 1);
        }        
    }

    return route;
}

export const ApiRoutes = {
    Graph: {
        GetUsers: params => compileRoute("/api/Graph/GetUsers", params)
    },
    Role: {
        GetRoles: params => compileRoute("/api/Role/GetRoles", params),
        GetRole: params => compileRoute("/api/Role/GetRole", params)
    },
    User: {
        GetMe: params => compileRoute("/api/User/GetMe", params),
        GetUser: params => compileRoute("/api/User/GetUser", params),
        GetAOFOpeners: params => compileRoute("/api/User/GetAOFOpeners", params),
        GetUserTodos: () => "/api/User/GetUserTodos",
        GetUserStatistics: () => "/api/User/GetUserStatistics",
        GetInvolvedUsers: params =>  compileRoute("/api/User/GetInvolvedUsers", params),
        AddUserInRole: () => "/api/User/AddUserInRole",
        UpdateUserInRole: () => "/api/User/UpdateUserInRole",
        RemoveUserFromRole: params => compileRoute("/api/User/RemoveUserFromRole", params)
    },
    Table: {
        GetTableDefinitions: params => compileRoute("/api/Table/GetTableDefinitions", params),
        GetChoosenTableDefinitions: params => compileRoute("/api/Table/GetChoosenTableDefinitions", params),
        GetTableDefinition: params => compileRoute("/api/Table/GetTableDefinition", params),
        GetTableValues: params => compileRoute("/api/Table/GetTableValues", params),
        GetAppSettings: params => compileRoute("/api/Table/GetAppSettings", params),
        GetAccountGroupMappingsECC: () => "/api/Table/GetAccountGroupMappingsECC",
        GetAccountGroupMappingsS4: () => "/api/Table/GetAccountGroupMappingsS4",
        AddTableValue: () => "/api/Table/AddTableValue",
        AddAccountGroupMappingECC: () => "/api/Table/AddAccountGroupMappingECC",
        AddAccountGroupMappingS4: () => "/api/Table/AddAccountGroupMappingS4",
        UpdateTableValue: () => "/api/Table/UpdateTableValue",
        UpdateAppSetting: () => "/api/Table/UpdateAppSetting",
        DeleteTableValue: params => compileRoute("/api/Table/DeleteTableValue", params),
        DeleteAccountGroupMapping: params => compileRoute("/api/Table/DeleteAccountGroupMapping", params)
    },
    Request: {
        GetSalesGroups: params => compileRoute("/api/Request/GetSalesGroups", params),
        GetUserSalesGroups: params => compileRoute("/api/Request/GetUserSalesGroups", params),
        GetUserCompanies: params => compileRoute("/api/Request/GetUserCompanies", params),
        GetBusinessCategories: params => compileRoute("/api/Request/GetBusinessCategories", params),
        GetUserBusinessCategories: params => compileRoute("/api/Request/GetUserBusinessCategories", params),
        GetUserSalesOrganizations: params => compileRoute("/api/Request/GetUserSalesOrganizations", params),
        GetTaxCategories: params => compileRoute("/api/Request/GetTaxCategories", params),
        GetCustomerGroups7: () => "/api/Request/GetCustomerGroups7",
        GetCustomerGroups8: params => compileRoute("/api/Request/GetCustomerGroups8", params),
        GetCustomerGroups9: () => "/api/Request/GetCustomerGroups9",
        GetCustomerGroups10: params => compileRoute("/api/Request/GetCustomerGroups10", params),
        GetDistributionChannels: params => compileRoute("/api/Request/GetDistributionChannels", params),
        GetCustGroupsWithAccGroupS4: params => compileRoute("/api/Request/GetCustGroupsWithAccGroupS4", params),
        GetCustGroupsWithAccGroupECC: params => compileRoute("/api/Request/GetCustGroupsWithAccGroupECC", params),
        GetInfoTypes: () => "/api/Request/GetInfoTypes",
        GetSegments: params => compileRoute("/api/Request/GetSegments", params),
        GetReconciliationAccounts: params => compileRoute("/api/Request/GetReconciliationAccounts", params),
        GetAccountingClerks: params => compileRoute("/api/Request/GetAccountingClerks", params),
        GetDeliveringPlants: params => compileRoute("/api/Request/GetDeliveringPlants", params),
        GetDraftRequests: params => compileRoute("/api/Request/GetDraftRequests", params),
        GetRunningRequests: params => compileRoute("/api/Request/GetRunningRequests", params),
        GetCompletedRequests: params => compileRoute("/api/Request/GetCompletedRequests", params),
        GetCustomerRequestDbType: params => compileRoute("/api/Request/GetCustomerRequestDbType", params),   
        GetCustomerRequestECC: params => compileRoute("/api/Request/GetCustomerRequestECC", params),   
        GetCustomerRequestS4: params => compileRoute("/api/Request/GetCustomerRequestS4", params),
        GetRequestSavedObsoleteDataECC: params => compileRoute("/api/Request/GetRequestSavedObsoleteDataECC", params),
        GetCustomerRequestHistory: params => compileRoute("/api/Request/GetCustomerRequestHistory", params),
        GetRespAreas: params => compileRoute("/api/Request/GetRespAreas", params), 
        GetSalesOffices: params => compileRoute("/api/Request/GetSalesOffices", params),
        SaveCustomerRequestDraftECC: () => "/api/Request/SaveCustomerRequestDraftECC",
        SaveCustomerRequestDraftS4: () => "/api/Request/SaveCustomerRequestDraftS4",
        SendCustomerRequestDraftECC: () => "/api/Request/SendCustomerRequestDraftECC",
        SendCustomerRequestDraftS4: () => "/api/Request/SendCustomerRequestDraftS4",
        DeleteCustomerRequestDraft: params => compileRoute("/api/Request/DeleteCustomerRequestDraft", params),
        UpdateCreditRiskInfoECC: () => "/api/Request/UpdateCreditRiskInfoECC",
        UpdateCreditRiskInfoS4: () => "/api/Request/UpdateCreditRiskInfoS4",
        SendCreditRiskInfoECC: () => "/api/Request/SendCreditRiskInfoECC",
        SendCreditRiskInfoS4: () => "/api/Request/SendCreditRiskInfoS4",
        BlockRequestECC: () => "/api/Request/BlockRequestECC",
        BlockRequestS4: () => "/api/Request/BlockRequestS4",
        UnblockRequest: () => "/api/Request/UnblockRequest",
        CloseRequest: () => "/api/Request/CloseRequest",
        UpdateSignedContractECC: () => "/api/Request/UpdateSignedContractECC",
        UpdateSignedContractS4: () => "/api/Request/UpdateSignedContractS4",
        SendSignedContractECC: () => "/api/Request/SendSignedContractECC",
        SendSignedContractS4: () => "/api/Request/SendSignedContractS4",
        UpdateLogisticDocInfoECC: () => "/api/Request/UpdateLogisticDocInfoECC",
        UpdateLogisticDocInfoS4: () => "/api/Request/UpdateLogisticDocInfoS4",
        SendLogisticDocInfoECC: () => "/api/Request/SendLogisticDocInfoECC",
        SendLogisticDocInfoS4: () => "/api/Request/SendLogisticDocInfoS4",
        UpdateLogisticCuSrvInfoECC: () => "/api/Request/UpdateLogisticCuSrvInfoECC",
        UpdateLogisticCuSrvInfoS4: () => "/api/Request/UpdateLogisticCuSrvInfoS4",
        SendLogisticCuSrvInfoECC: () => "/api/Request/SendLogisticCuSrvInfoECC",
        SendLogisticCuSrvInfoS4: () => "/api/Request/SendLogisticCuSrvInfoS4",
        UpdateLogisticPlanInfoECC: () => "/api/Request/UpdateLogisticPlanInfoECC",
        UpdateLogisticPlanInfoS4: () => "/api/Request/UpdateLogisticPlanInfoS4",
        SendLogisticPlanInfoECC: () => "/api/Request/SendLogisticPlanInfoECC",
        SendLogisticPlanInfoS4: () => "/api/Request/SendLogisticPlanInfoS4",
        UpdatePricingInfo: () => "/api/Request/UpdatePricingInfo",
        SendCustomerRequestToARFromPricing: () => "/api/Request/SendCustomerRequestToARFromPricing",
        UpdateAccountReceivableInfoECC: () => "/api/Request/UpdateAccountReceivableInfoECC",
        UpdateAccountReceivableInfoS4: () => "/api/Request/UpdateAccountReceivableInfoS4",
        SendAccountReceivableInfoECC: () => "/api/Request/SendAccountReceivableInfoECC",
        SendAccountReceivableInfoS4: () => "/api/Request/SendAccountReceivableInfoS4",
        SendCustomerRequestToReview: () =>"/api/Request/SendCustomerRequestToReview",
        SendCustomerRequestToCreditRisk: () => "/api/Request/SendCustomerRequestToCreditRisk",
        SendCustomerRequestToLogistic: () => "/api/Request/SendCustomerRequestToLogistic",
        SendCustomerRequestToCRE: () => "/api/Request/SendCustomerRequestToCRE",
        SendCustomerRequestToARFromCR: () => "/api/Request/SendCustomerRequestToARFromCR",
        ReSendCustomerRequestToSap: params => compileRoute("/api/Request/ReSendCustomerRequestToSap", params),
        RejectCustomerRequest: () => "/api/Request/RejectCustomerRequest",        
        AbortCustomerRequest: params => compileRoute("/api/Request/AbortCustomerRequest", params),        
        GetRequestHistoryExcel: params => compileRoute("/api/Request/GetRequestHistoryExcel", params)
     },
     Sap: {
        ValidateCode: () => "/api/Sap/ValidateCode"
    },
    File: {
        UploadECC: () => "/api/File/UploadECC",
        UploadS4: () => "/api/File/UploadS4",
        Download: params => compileRoute("/api/File/Download", params)
    }
};

export const FetchContext = React.createContext(null);

export const FetchProvider = (props) => {
    const { instance } = useMsal();
    const { enqueueSnackbar } = useSnackbar();
    const snackOptions: OptionsObject = { variant: "error", autoHideDuration: 5000 };

    const createError = (code, message) => {
        const error = new Error(message);
        error.cause = code;
        return error;
    }

    // source: https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    /*const fetchRetry = (api, cfg, retries) =>
        fetch(api, cfg)
        .catch((error) => {
            if (retries === 1)
                throw error;

            return fetchRetry(api, cfg, retries - 1);
        });*/

    const fetchAuthorized = async (api, cfg) => {
        const authResult: AuthenticationResult = await aquireToken(instance);
        const accessToken: string = authResult.accessToken;

        if (cfg.headers) {
            if (cfg.body && (typeof cfg.body === 'string' || cfg.body instanceof String))
                cfg.headers["Content-Type"] = "application/json";

            cfg.headers["Cache-Control"] = "no-cache";
            cfg.headers["Pragma"] = "no-cache";
            cfg.headers["Expires"] = "0";
            cfg.headers["Authorization"] = `Bearer ${accessToken}`;
        }
        else {
            const headerProperties = {
                "Cache-Control": "no-cache",
                "Pragma": "no-cache",
                "Expires": "0",
                "Authorization": `Bearer ${accessToken}`
            };

            if (
                api !== ApiRoutes.File.UploadECC() &&
                api !== ApiRoutes.File.UploadS4()
            )
                headerProperties["Content-Type"] = "application/json";

            cfg = {
                ...cfg,
                cache: 'no-cache',
                headers: new Headers(headerProperties)
            };
        }

        return fetch(_clientSettings.backendApiUrl + api, cfg)
            .then(response => {
                if (response.ok)
                    return response;
                else {
                    switch (response.status) {
                        // Bad Request
                        case 400:
                            return response.json()
                                .then(data => {
                                    if (data.errors) {
                                        const errorKeys = Object.keys(data.errors);
                                        
                                        if (cfg.collectErrorDetails) {                                            
                                            const error = new Error("Invalid data supplied");
                                            error.stack = JSON.stringify(errorKeys.map(x => ({ errorId: x,  message: data.errors[x][0]})));
                                            error.cause = response.status;
                                            return Promise.reject(error);
                                        }
                                        else {
                                            errorKeys.forEach(errorKey => {
                                                const error = data.errors[errorKey][0];                                            
                                                enqueueSnackbar(error, snackOptions);
                                            });
                                        }
                                    }
                                    return Promise.reject(createError(response.status, "Invalid data supplied"));
                                });
                        // Unauthorized
                        case 401:
                            return Promise.reject(createError(response.status, "User is not authorized"));
                        // Forbidden
                        case 403:                         
                            return Promise.reject(createError(response.status, "User is not allowed"));
                        // Not Found
                        case 404:
                            return Promise.reject(createError(response.status, "Resource not found"));
                        // Server Error
                        case 500:
                            return response.json()
                                .then(data => {
                                    let message = null;
                                    if (data.message) message = data.message;
                                    else message = "An internal error occured";
                                    return Promise.reject(createError(response.status, message));
                                });
                        // Not handled
                        default:
                            return Promise.reject(createError(response.status, "Something went bad"));
                    }
                }
            })
            .catch(error => {
                //AbortError is caused by debounce when searching users
                if (!cfg.silent && error.name !== "AbortError")
                    enqueueSnackbar(error.message, snackOptions);

                return Promise.reject(error);
            });
    };

    const { Provider } = FetchContext;

    return (
        <Provider value={{
            //fetchRetry,
            fetchAuthorized
        }}>
            {props.children}
        </Provider>
    );
}